import moment from 'moment';

import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ensure } from 'components/sharpr/ensure/ensure';

export default function AffiliationAnalyticsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.AffiliationAnalytics', {
		url: '/admin/account/analytics?startDate&endDate',
		controllerAs: 'vm',
		controller: AffiliationAnalyticsCtrl,
		templateUrl: '/ng/hub/Account/Analytics/AccountAnalyticsCtrl.html?' + window.BUILD,
		permission: ['manage_hubs'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Account/Analytics/AccountAnalyticsCtrl.css'),
		},
	});
}

class AffiliationAnalyticsCtrl {
	constructor($window, Api, $stateParams, $state, Identity) {
		'ngInject';
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$window = $window;
		this.Api = Api;
		this.Identity = Identity;
	}

	$onInit() {
		this.dateRange = [this.getInitialStartDate(this.$stateParams), this.getInitialEndDate(this.$stateParams)];

		// Set all hubs to initially be selected
		this.selectedHubIds = this.Identity.hubIdsInThisAccount();
		this.affiliationId = this.Identity.currentAffiliationId();
		this.updateCharts();
	}

	getInitialStartDate($stateParams) {
		let start = moment($stateParams.startDate, 'YYYY-MM-DD');
		if (start.isValid()) {
			return start.format('YYYY-MM-DD');
		} else {
			return moment().subtract(29, 'days').format('YYYY-MM-DD');
		}
	}

	getInitialEndDate($stateParams) {
		let start = moment($stateParams.endDate, 'YYYY-MM-DD');
		if (start.isValid()) {
			return start.format('YYYY-MM-DD');
		} else {
			return moment().format('YYYY-MM-DD');
		}
	}

	dateChanged() {
		window.location.href = this.$state.href(
			'hub.loggedin.AffiliationAnalytics',
			{ startDate: this.dateRange[0], endDate: this.dateRange[1] },
			{ notify: false }
		);
		this.updateCharts();
	}

	selectedHubsChanged() {
		window.location.href = this.$state.href(
			'hub.loggedin.AffiliationAnalytics',
			{ startDate: this.dateRange[0], endDate: this.dateRange[1], hubs: this.selectedHubIds },
			{ notify: false }
		);
		this.updateCharts();
	}

	updateCharts() {
		this.updatePostsPerInstance();
		this.updateTopContributors();
		this.updateTagCloud();
		this.updateEmailBriefsSent();
	}

	updatePostsPerInstance() {
		let dateRangeQueryString = this._getDateRangeQueryString();
		let url = '/affiliations/top_posts_per_hub?limit=10&' + dateRangeQueryString;
		url = url + '&client_ids=' + this.selectedHubIds.join(',');
		this.Api.get(url).then(post_counts => {
			this.postsPerInstancePreparedData = ensure.array(post_counts).map(post_count => {
				return {
					value: Number(post_count.posts_count),
					label: post_count.Client.name,
				};
			});
		});
	}

	updateTopContributors() {
		let dateRangeQueryString = this._getDateRangeQueryString();
		let url = '/affiliations/top_contributors?limit=10&' + dateRangeQueryString;
		url = url + '&client_ids=' + this.selectedHubIds.join(',');
		this.Api.get(url).then(top_contributors => {
			this.topContributorsPreparedData = ensure.array(top_contributors).map(contrib => {
				return {
					value: contrib.post_count,
					label: contrib.User.fname + ' ' + contrib.User.lname,
				};
			});
		});
	}

	updateTagCloud() {
		let dateRangeQueryString = this._getDateRangeQueryString();
		let url = '/affiliations/tag_cloud?top=30&' + dateRangeQueryString;
		url = url + '&client_ids=' + this.selectedHubIds.join(',');
		url = url + '&affiliation_id=' + this.affiliationId;
		this.Api.get(url).then(tagCloudData => {
			this.tagCloudData = tagCloudData;
		});
	}

	updateEmailBriefsSent() {
		let dateRangeQueryString = this._getDateRangeQueryString();
		let url = '/affiliations/top_email_briefs_sent?limit=10&' + dateRangeQueryString;
		url = url + '&client_ids=' + this.selectedHubIds.join(',');
		this.Api.get(url).then(emailBriefsSent => {
			this.emailBriefsSentPreparedData = ensure.array(emailBriefsSent).map(emailBrief => {
				return {
					value: emailBrief.emails,
					label: emailBrief.Client.name,
				};
			});
		});
	}

	_getDateRangeQueryString() {
		let query = [];
		if (this.dateRange[0]) {
			query.push('since_date=' + encodeURIComponent(this.dateRange[0]));
		}
		if (this.dateRange[1]) {
			query.push('before_date=' + encodeURIComponent(this.dateRange[1]));
		}
		return query.join('&');
	}
}
